<template>
  <div class="columns" :class="{empty: !chosen}">

    <div class="page">
      <div class="searchBox">
        <form @submit.prevent class="filterSearch">
          <div class="filters">
            <div class="select">
              <label for="roleFilter">Role</label>
              <select v-model="type" id="roleFilter" class="input">
                <option value="all">All</option>
                <option value="mentor">Mentors</option>
                <option value="attendee">Attendees</option>
                <option value="volunteer">Volunteers</option>
              </select>
            </div>
            <div class="select">
              <label for="genderFilter">Gender</label>
              <select id="genderFilter" v-model="genderFilter" class="input">
                <option value="all">All</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="nonBinary">Non-Gender Binary</option>
                <option value="other">Other</option>
                <option value="preferNotToSay">Prefer not to say</option>
              </select>
            </div>
            <div class="select">
              <label for="allergieFilter">Allergies</label>
              <select id="allergieFilter" class="input">
                <option value="all">All</option>
                <option value="none">No allergies</option>
                <option value="yes">Have allergies</option>
              </select>
            </div>
            <div class="select">
              <label for="dietaryFilter">Dietary Restrictions</label>
              <select id="dietaryFilter" class="input">
                <option value="all">All</option>
                <option value="none">No dietary restrictions</option>
                <option value="yes">Have dietary restrictions</option>
              </select>
            </div>
            <div class="select">
              <label for="waiversFilter">Waiver Status</label>
              <select id="waiversFilter" class="input">
                <option value="all">All</option>
                <option value="completed">completed</option>
                <option value="uncompleted">uncompleted</option>
              </select>
            </div>
          </div>
          <input v-model="searchTerm" type="search" class="input search" placeholder="Search">
          <div class="filters">
            <p>Results: {{searched.length}}</p>
            <p>{{Math.round((searched.length/roster.length) * 100)}}% of total records</p>
            <div class="emails">
              <label for="emails">Emails:</label>
              <div class="email__container" @click="copyEmails">
                <input id="emailsCopy" readonly type="text" placeholder="emails" v-model="emails">
                <p>Click to copy</p>
              </div>

            </div>
            <button class="btn--dark" @click="reset">Reset</button>
          </div>
        </form>
        <div class="rosterHeader">
          <p>Name</p>
          <p>School/Work</p>
          <p class="right">Role</p>
          <p class="right">Waiver</p>
          <p class="right">On Campus</p>
          <p class="right">Showed Up</p>
        </div>

      </div>
      <div class="people">
        <div @click="openPerson(app)" :class="{active:chosen == app['_id']} " :key="app['_id']" v-for="app in searched"
             class="person rosterPerson">
          <p>{{app.firstName}} {{app.lastName}}</p>
          <p>{{app.application.school? app.application.school : app.application.company}}</p>
          <p class="right">{{app.role}}</p>
          <p class="right">None</p>
          <p class="right">false</p>
          <p class="right">false</p>
        </div>
      </div>
    </div>
    <div v-if="chosen" class="column">
      <div class="name">
        <div>

          <h1 class="heading">{{focusedApp.firstName}} {{focusedApp.lastName}}</h1>
          <p>{{focusedApp.application.school ? `${focusedApp.application.school}, ${focusedApp.application.graduation}
            `: focusedApp.application.company}}</p>
        </div>
        <p>{{focusedApp.role}}</p>
      </div>
      <div class="appData">
        <p class="sectionTitle">Info</p>
        <p class="info">email: <span>{{focusedApp.email}}</span></p>
        <div v-if="focusedApp.role == 'attendee'">
          <p class="info">Zipcode: <span>{{focusedApp.application.zip}}</span></p>
          <p class="info">Birthday: <span>{{focusedApp.application.birthday}}</span></p>
          <p class="info">Gender: <span>{{focusedApp.application.gender}}</span></p>
          <p class="question">Race: <span>{{objList(focusedApp.application.race)}}</span></p>
        </div>
        <div v-if="focusedApp.role == 'mentor'">
          <p class="info">Phone: <span>{{focusedApp.application.phoneNumber}}</span></p>
          <p class="info">Company: <span>{{focusedApp.application.company}}</span></p>
          <p class="info">Position: <span>{{focusedApp.application.companyPosition}}</span></p>
        </div>
        <p class="sectionTitle">Questions</p>
        <div v-if="focusedApp.role == 'mentor'">
          <p class="question">Experience Attending Hackathons: <span>{{focusedApp.application.expAttending}}</span></p>
          <p class="question">Experience Mentoring or Judging Hackathons: <span>{{focusedApp.application.expMentoringJudging}}</span>
          </p>
          <p class="question">Experience Working with High School Students: <span>{{focusedApp.application.expWorkingWithStudents}}</span>
          </p>
          <p class="question">Areas of expertise: <span>{{focusedApp.application.areasOfExpertise}}</span></p>
        </div>
        <div v-if="focusedApp.role == 'attendee'">
          <p class="question">Why do you want to attend?: <span>{{focusedApp.application.whyDoYouWantToAttend}}</span>
          </p>
          <p class="question">Experience with software development:
            <span>{{focusedApp.application.experienceSoftware}}</span></p>
          <p class="question">Experience with hardware development:
            <span>{{focusedApp.application.experienceHardware}}</span></p>
          <p class="question">Experience with hackathons: <span>{{focusedApp.application.experienceHackathon}}</span>
          </p>
          <p class="question">Experience with team coding: <span>{{focusedApp.application.experienceTeamCoding}}</span>
          </p>
          <p class="question">Description of computer science experience: <span>{{focusedApp.application.descriptionCompSciExp}}</span>
          </p>
          <p class="info">Coming with team: <span>{{focusedApp.application.team? "Yes" : "No"}}</span></p>

        </div>
        <p class="sectionTitle">Logistics</p>
        <p v-if="focusedApp.role == 'attendee'" class="info">Laptop: <span>{{focusedApp.application.laptop? "Yes" : "No"}}</span>
        </p>
        <p class="question">Food Allergies: <span>{{objList(focusedApp.application.foodAllergies)}}</span></p>
        <p class="question">Dietary Restrictions: <span>{{objList(focusedApp.application.dietaryRestrictions)}}</span>
        </p>
        <p class="question">Accommodations: <span>{{focusedApp.application.accommodations}}</span></p>
        <p class="info">Shirt Size: <span>{{focusedApp.application.shirtSize}}</span></p>
        <p class="question">Referrers: <span>{{objList(focusedApp.application.referrers)}}</span></p>
        <p class="question">Comments: <span>{{focusedApp.application.comments}}</span></p>
      </div>

    </div>
    <div v-if="!chosen" class="column empty">
      <p>Click on someone to get details about them</p>
    </div>

  </div>
</template>

<script>

  import Loader from "../components/Loader"

  export default {
    name: 'Home',
    components: {
      Loader
    },
    data() {
      return {
        chosen: false,
        search: new this.$JsSearch.Search('_id'),
        "searchTerm": "",
        type: "all",
        declineModal: false,
        declineReasons: "",
        declineLoading: false,
        acceptLoading: false,
        genderFilter: "all"

      }
    },
    methods: {
      filterSearch(item) {
        let result = true
        if (this.type == "all") {
        } else if (item.role != this.type) {
          result = false
        }
        if (this.genderFilter == "all") {
        } else if (item.application.gender != this.genderFilter) {
          result = false
        }
        return result
      },
      copyEmails() {
        var copyText = document.getElementById("emailsCopy");

        /* Select the text field */
        copyText.select();

        /* Copy the text inside the text field */
        document.execCommand("copy");

      },
      reset() {
        this.type = "all"
        this.searchTerm = ""
        this.genderFilter = "all"
      },
      objList(obj) {
        let terms = []
        Object.keys(obj).forEach(i => {
          if (i === "otherEnabled" && obj.otherEnabled) {
            // console.log(obj.otherEnabled, obj.other)
            terms.push(obj.other)
          } else {
            if (obj[i] && i != "other") {
              terms.push(i)
            }
          }

        })
        return String(terms)
      },
      relativeTime(time) {
        return this.$moment.unix(time).fromNow()
      },
      openPerson(app) {
        this.chosen = app["_id"]
        console.log(window.screen.width)
        if (window.screen.width <= 1339) {
          this.$parent.$data.navMinimized = true
        }

      }
    },
    computed: {
      focusedApp() {
        if (this.chosen) {
          return this.rosterObject[this.chosen]
        } else {
          return false
        }

      },
      roster() {
        this.search = new this.$JsSearch.Search('_id')
        this.search.addIndex('firstName');
        this.search.addIndex('lastName');
        this.search.addIndex('email');
        this.search.addIndex('role');
        this.search.addIndex(['application', 'school']);
        this.search.addIndex(['application', 'company']);
        this.search.addDocuments(this.$store.getters.roster)
        return this.$store.getters.roster.sort((a, b) => {
          return a.applied - b.applied
        })
      },

      searched() {
        console.log(this.type)
        if (this.searchTerm.length >= 1) {

          return this.search.search(this.searchTerm).filter(item => this.filterSearch(item))


        } else {

          return this.roster.filter(item => {
            return this.filterSearch(item)
          })

        }

      },
      emails: {
        get() {
          return this.searched.map(i => {
            return i.email
          })
        },
        set() {
          return
        }


      },
      rosterObject() {
        return this.$store.getters.rosterObject
      }
    },
    mounted() {

      fetch(this.$store.getters.api + "/api/v1/admin/roster", {
        method: "get",
        headers: {
          "Authorization": this.$store.getters.token
        }
      }).then(async res => {
        let json = await res.json()
        console.log(json, res.status)
        if (json.roster) {
          this.$store.commit("roster", json.roster)
        } else {
          this.$swal("Error fetching roster")
        }
      })
    }

  }
</script>
